import { usePageTitle } from '@/hooks/use-document-title'
import Footer from './footer'

interface PolicySection {
  title: string
  body: string
}

const sections: PolicySection[] = [
  {
    title: 'Accounts',
    body: 'You are responsible for your account and for keeping your login credentials confidential. You agree to provide accurate information when signing up and to keep it up to date. Accounts are personal — sharing an account or purchased access with others is not permitted.',
  },
  {
    title: 'Access to the Service',
    body: 'We grant you a limited, non-transferable license to use Beyond CTCI for your own interview preparation. You may not resell, redistribute, scrape, or commercially exploit the platform or its content, or attempt to reverse-engineer any part of the service.',
  },
  {
    title: 'Acceptable Use',
    body: 'Do not use the service to do anything unlawful, to harass others, to upload malicious code, or to attempt unauthorized access to our systems or other users’ data. We may suspend or terminate accounts that violate this policy.',
  },
  {
    title: 'Coaching and Content',
    body: 'Coaching guidance, editorials, and other content are provided for educational purposes. We work hard to keep them accurate and current, but we make no guarantee about interview outcomes, offers, or compensation results.',
  },
  {
    title: 'Payments',
    body: 'Paid offerings are billed through our payment processor and are subject to its terms. Except where required by law or stated otherwise at purchase, payments are non-refundable.',
  },
  {
    title: 'Disclaimers and Limitation of Liability',
    body: 'The service is provided “as is” without warranties of any kind. To the maximum extent permitted by law, Beyond CTCI is not liable for indirect, incidental, or consequential damages arising from your use of the service.',
  },
  {
    title: 'Termination',
    body: 'You may stop using the service at any time. We may suspend or terminate access for violations of these terms. Sections that by their nature should survive termination will do so.',
  },
  {
    title: 'Changes to These Terms',
    body: 'We may update these terms from time to time. When we make material changes we will update this page, and continued use of the service after changes take effect constitutes acceptance.',
  },
  {
    title: 'Contact',
    body: 'Questions about these terms? Reach out through the contact information on our About Us page.',
  },
]

export default function TermsOfService() {
  usePageTitle('Terms of Service')

  return (
    <div className="flex min-h-[calc(100vh-4rem)] flex-col">
      <div className="container mx-auto max-w-4xl px-4 py-12">
        <h1 className="mb-4 text-4xl font-bold tracking-tight">
          Terms of Service
        </h1>
        <p className="text-muted-foreground mb-12 max-w-3xl text-lg leading-relaxed">
          These terms govern your use of the Beyond CTCI platform and coaching
          program. By creating an account or using the service, you agree to
          them.
        </p>

        {sections.map(({ title, body }) => (
          <section key={title} className="mb-10">
            <h2 className="mb-3 text-2xl font-semibold">{title}</h2>
            <p className="text-muted-foreground leading-relaxed">{body}</p>
          </section>
        ))}
      </div>
      <Footer />
    </div>
  )
}
